import * as THREE from "three"

import Sizes from "./Utils/Sizes.js"
import Time from "./Utils/Time.js"
import Camera from "./Camera.js"
import Renderer from "./Renderer.js"
import World from "./World/World.js"
import Resources from "./Utils/Resources.js"
import sources from "./sources.js"
import Screen from "./World/Screen.js"
import Debug from "./Utils/Debug.js"
import LoadingScreen from "./Utils/LoadingScreen.js"

let instance = null
export default class Experience {

    constructor(canvas) {
        if (instance) {
            return instance
        }

        instance = this

        // Global Access
        window.experience = this

        // Options
        this.canvas = canvas

        // Setup
        this.debug = new Debug()
        this.sizes = new Sizes()
        this.time = new Time()
        this.scene = new THREE.Scene()
        this.resources = new Resources(sources)
        this.loadingScreen = new LoadingScreen()

        if (this.canvas) {
            this.camera = new Camera()
            this.renderer = new Renderer()
            this.world = new World()

            // Create iframe element (now wrapper)
            this.iframe = document.querySelector('.screen');

            // Pass iframe to Screen class
            if (this.iframe) {
                this.screen = new Screen(this.iframe)
                this.setScreenKeyboardBridge()
            }


            // Sizes resize event
            this.sizes.on("resize", () => {
                this.resize()
            })

            // Time tick event
            this.time.on("tick", () => {
                this.update()
            })
        }
    }

    resize() {
        if (!this.canvas) return
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        if (!this.canvas) return
        this.camera.update()
        this.renderer.update()
        if (this.screen) {
            this.screen.update()
        }
        this.world.update()
    }

    setScreenKeyboardBridge() {
        this.forwardedKeys = new Set([
            "KeyW",
            "KeyS",
            "ArrowUp",
            "ArrowDown",
            "Space",
            "Enter",
            "Escape"
        ])

        this.handleScreenKeyboardBridge = (event) => {
            if (!this.camera?.isZoomedIn) {
                return
            }

            if (!this.forwardedKeys.has(event.code)) {
                return
            }

            const targetWindow = this.iframe?.contentWindow

            if (!targetWindow) {
                return
            }

            targetWindow.dispatchEvent(new KeyboardEvent("keydown", {
                key: event.key,
                code: event.code,
                bubbles: true
            }))
        }

        window.addEventListener("keydown", this.handleScreenKeyboardBridge)
    }

}
